"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
var _utils = require("../utils");
var _icon = _interopRequireDefault(require("../icon"));
var _popup = _interopRequireDefault(require("../popup"));
var _button = _interopRequireDefault(require("../button"));
var _buttonGroup = _interopRequireDefault(require("../button-group"));
var _use = (0, _utils.use)('action-picker'),
  sfc = _use[0],
  bem = _use[1];
var _default2 = sfc({
  props: {
    value: Boolean,
    title: String,
    titleTag: String,
    subTitle: String,
    transition: String,
    position: String,
    showBack: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    forceAdapteiPhoneX: Boolean,
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    lazyRender: {
      type: Boolean,
      default: true
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: '确定'
    },
    btnProps: Object,
    showCancelBtn: {
      type: Boolean,
      default: false
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    closeOnPopstate: {
      type: Boolean,
      default: true
    },
    cancelBtnProps: Object,
    lineFeed: Boolean,
    getContainer: [String, Function],
    height: {
      type: String,
      default: '50vh'
    },
    keepRender: {
      type: Boolean,
      default: true
    },
    customPopStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    zIndex: [Number, String],
    dynamicLockScroll: {
      type: String,
      default: 'auto'
    },
    beforeClose: Function
  },
  methods: {
    onConfirm: function onConfirm() {
      this.$emit('confirm', this.close.bind(this));
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
      this.close();
    },
    onBack: function onBack() {
      this.$emit('back', this.close.bind(this));
    },
    onClose: function onClose() {
      var _this = this;
      if (this.beforeClose) {
        // action 便于扩展， 定义 close
        var action = 'close';
        this.beforeClose(action, function (state) {
          if (state !== false) {
            _this.$emit('close');
            _this.close();
          }
        });
        return;
      }
      this.$emit('close');
      this.close();
    },
    // exposed method
    close: function close() {
      this.$emit('input', false);
    }
  },
  render: function render(h) {
    var _this$$vnode,
      _this$$vnode$data,
      _this2 = this;
    var Back = this.showBack && h("div", {
      "on": {
        "click": this.onBack
      },
      "class": "back-zone"
    }, [h(_icon.default, {
      "attrs": {
        "name": 'https://pic5.zhuanstatic.com/zhuanzh/2f485231-4267-4130-9f52-048e89c56e8d.png'
      }
    })]);
    var Close = this.showClose && h("div", {
      "on": {
        "click": this.onClose
      },
      "class": "close-zone"
    }, [h(_icon.default, {
      "attrs": {
        "classPrefix": 'zziconfont-6',
        "name": 'close'
      }
    })]);
    var Tag = this.titleTag && h("span", {
      "class": "title-tag"
    }, [this.titleTag]);
    var Sub = !this.titleTag && this.subTitle && h("span", {
      "class": "sub-title"
    }, [this.subTitle]);
    var hasTitle = this.title && this.showClose;
    var hasBtn = this.showBtn || this.showCancelBtn;
    var hasTopSlot = this.$slots['top-left'] || this.$slots['top-center'] || this.$slots['top-right'] || this.$slots['top-insert'];
    var bemClass = bem({
      'with-top-slot': hasTopSlot,
      'with-top-insert': this.$slots['top-insert']
    });
    if ((_this$$vnode = this.$vnode) !== null && _this$$vnode !== void 0 && (_this$$vnode$data = _this$$vnode.data) !== null && _this$$vnode$data !== void 0 && _this$$vnode$data.staticClass) {
      bemClass.push(this.$vnode.data.staticClass);
    }
    return (this.value || this.keepRender) && h("div", [h(_popup.default, {
      "class": bemClass,
      "attrs": {
        "position": this.position || 'bottom',
        "value": this.value,
        "overlay": this.overlay,
        "lazyRender": this.lazyRender,
        "transition": this.transition,
        "getContainer": this.getContainer,
        "forceAdapteiPhoneX": this.forceAdapteiPhoneX,
        "closeOnClickOverlay": this.closeOnClickOverlay,
        "closeOnPopstate": this.closeOnPopstate,
        "zIndex": this.zIndex,
        "dynamicLockScroll": this.dynamicLockScroll
      },
      "on": {
        "open": function open() {
          return _this2.$emit('afterEnter');
        },
        "closed": function closed() {
          return _this2.$emit('afterLeave');
        },
        "click-overlay": function clickOverlay() {
          return _this2.$emit('click-overlay');
        },
        "input": function input(value) {
          return _this2.$emit('input', value);
        }
      },
      "style": Object.assign({
        height: this.height
      }, this.customPopStyle)
    }, [this.title && h("div", {
      "class": bem('title', {
        tag: this.titleTag,
        sub: !this.titleTag && this.subTitle
      })
    }, [Back, h("span", {
      "class": "title-text"
    }, [this.title]), Tag, Sub, Close]), !this.title && this.showClose && h("div", {
      "class": bem('close', {
        'hide-title': !this.title
      })
    }, [Back, Close]), h("div", {
      "class": bem('content', {
        'no-title': !hasTitle
      })
    }, [this.slots()]), h("TransitionGroup", {
      "attrs": {
        "name": "z-fade"
      }
    }, [this.value && this.$slots['top-left'] && h("div", {
      "key": "left",
      "class": bem('top-left')
    }, [this.slots('top-left')]), this.value && this.$slots['top-center'] && h("div", {
      "key": "center",
      "class": bem('top-center')
    }, [this.slots('top-center')]), this.value && this.$slots['top-right'] && h("div", {
      "key": "right",
      "class": bem('top-right')
    }, [this.slots('top-right')]), this.value && this.$slots['top-insert'] && h("div", {
      "key": "insert",
      "class": bem('top-insert')
    }, [this.slots('top-insert')])]), this.$slots.btnGroup && h("div", {
      "class": bem('footer')
    }, [this.$slots.btnGroup]), !this.$slots.btnGroup && this.$slots.btn && h(_buttonGroup.default, {
      "attrs": {
        "insideCard": true,
        "fixed": false,
        "topStyle": " "
      },
      "class": bem('footer')
    }, [this.slots('btn')]), !this.$slots.btnGroup && !this.$slots.btn && hasBtn && h(_buttonGroup.default, {
      "attrs": {
        "insideCard": true,
        "fixed": false,
        "topStyle": " "
      },
      "class": bem('footer', {
        'single-line': !this.lineFeed,
        'line-feed': this.lineFeed
      })
    }, [this.showCancelBtn && h(_button.default, {
      "props": Object.assign({}, Object.assign({
        size: 'large'
      }, this.cancelBtnProps)),
      "class": bem('cancel', {
        'not-alone': this.showBtn
      }),
      "on": {
        "click": this.onCancel
      }
    }, [this.cancelBtnText]), this.showBtn && h(_button.default, {
      "props": Object.assign({}, Object.assign({
        type: 'primary',
        size: 'large'
      }, this.btnProps)),
      "attrs": {
        "v9": true
      },
      "class": bem('confirm', {
        'not-alone': this.showCancelBtn
      }),
      "on": {
        "click": this.onConfirm
      }
    }, [this.btnText])])])]);
  }
});
exports.default = _default2;